import type { DetailedHTMLProps, MetaHTMLAttributes } from "react"

type Arg = {
  title?: string
  description?: string
  socialTitle?: string
  socialDescription?: string
}

export const meta = ({
  title,
  description,
  socialTitle,
  socialDescription,
}: Arg) => {
  const items: DetailedHTMLProps<
    MetaHTMLAttributes<HTMLMetaElement>,
    HTMLMetaElement
  >[] = []
  const ogTitle = socialTitle ?? title
  const ogDescription = socialDescription ?? description

  if (title) {
    items.push({
      title: title.startsWith("PromptJuggler")
        ? title
        : `${title} – PromptJuggler`,
    })
  }
  if (description) {
    items.push({ name: "description", content: description })
  }
  if (ogTitle) {
    items.push({ property: "og:title", content: ogTitle })
  }
  if (ogDescription) {
    items.push({ property: "og:description", content: ogDescription })
  }
  if (ogTitle) {
    items.push({ name: "twitter:title", content: ogTitle })
  }
  if (ogDescription) {
    items.push({ name: "twitter:description", content: ogDescription })
  }

  return items
}
